export default __webpack_public_path__ + "static/media/like.da908fc6.png";